import { render, staticRenderFns } from "./DialogShowVideo.vue?vue&type=template&id=b83ea3ae&scoped=true"
import script from "./DialogShowVideo.vue?vue&type=script&lang=js"
export * from "./DialogShowVideo.vue?vue&type=script&lang=js"
import style0 from "./DialogShowVideo.vue?vue&type=style&index=0&id=b83ea3ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83ea3ae",
  null
  
)

export default component.exports